@for (operationGroup of operationGroups; track $index) {
  <ng-container>
    @if (!showSubMenusOnly) {
      <ng-container>
        <app-dropdown-menu
          [icon]="operationGroup.menu_icon"
          [text]="operationGroup.menu_title"
          [stylingClass]="'simple-setting-button'"
        >
          @for (operation of operationGroup.sub_operations; track $index) {
            <app-dropdown-menu-item
             class="operation-dropdown-menu__menu"
             [icon]="operation.menu_icon"
             (click)="openOperation(operation)"
             (keydown)="null"
             [text]="operation.menu_title"
            ></app-dropdown-menu-item>
          }
        </app-dropdown-menu>
      </ng-container>
    }
    @else {
      <ng-container>
        @for (operation of operationGroup.sub_operations; track $index) {
          <app-dropdown-menu-item
            class="operation-dropdown-menu__menu"
            [icon]="operation.menu_icon"
            (click)="openOperation(operation)"
            (keydown)="null"
            [text]="operation.menu_title"
          ></app-dropdown-menu-item>
        }
      </ng-container>
    }
  </ng-container>
}
